import { DataSecurityLevel, EVENT_CATEGORY, EVENT_NAME, FLIGHTS, SESSION_DETAILS, } from '@office-start/telemetry-types';
import { getFlattenedFieldName } from '@office-start/telemetry-utility';
import { getFlights, isTelemetryServiceInitialized, logEvent, } from '../TelemetryService';
export function logSession(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logEvent("Session" /* EventCategory.Session */, generateParams(properties), securityThreshold);
}
export function generateParams(properties) {
    var params = {};
    params[EVENT_CATEGORY] = "Session" /* EventCategory.Session */;
    params[EVENT_NAME] = properties.eventName;
    if (isTelemetryServiceInitialized()) {
        params[FLIGHTS] = getFlights();
    }
    return params;
}
export function isSessionEvent(params) {
    return params[EVENT_CATEGORY] === "Session" /* EventCategory.Session */;
}
export function setSessionInfo(params) {
    if (params[FLIGHTS]) {
        return params;
    }
    params[getFlattenedFieldName([SESSION_DETAILS, FLIGHTS])] = getFlights();
    return params;
}
//# sourceMappingURL=logSession.js.map